import { defineMessages } from 'react-intl'

const scope = `procurify.platform.auditLog.presenter.AuditLogRecord`

export default defineMessages({
  delegateeDetail: {
    id: `${scope}.delegateeDetail`,
    defaultMessage:
      '<strong>{delegateeUserName}</strong> on behalf of <strong>{userName}</strong>',
  },
})
